import { ISearch, IBaseSearch } from '@/models/Search';
declare const google: any;
declare const window: any;

class GMapsService {
    protected loadingPromise!: Promise<any>;
    protected geocoderCache: ISearch[] = [];

    public loadGoogleApi = (): Promise<any> => {
        const url = `//maps.google.com/maps/api/js?v=3&key=AIzaSyBy2lvy6Xa1t6YCATCLNmVG7GYtHjJf6mY&libraries=places&callback=__onGoogleLoaded`;

        if (window.google && window.google.maps) {
            // Google maps already loaded on the page.
            return Promise.resolve();
        }

        if (this.loadingPromise) {
            return this.loadingPromise;
        }

        this.loadingPromise = new Promise((resolve) => {
            window['__onGoogleLoaded'] = () => {
                resolve(window.gapi);
            }

            const node = document.createElement('script');
            node.src = url;
            node.type = 'text/javascript';
            document.getElementsByTagName('head')[0].appendChild(node);
        });

        return this.loadingPromise;
    }

    public getPredictions(query: string): Promise<any> {
        const service = new google.maps.places.AutocompleteService();

        return new Promise((resolve, reject) => {
            service.getQueryPredictions({ input: query }, (predictions: any[], status: string) => {
                resolve(predictions);
            });
        });
    }

    public getPredictionDetails(selector: string, reference: any) {
        const service = new google.maps.places.PlacesService();

        return new Promise((resolve, reject) => {
            service.getDetails({ reference }, (result: any, status: string) => {
                resolve(result);
            });
        });
    }

    public async geocode(query: string): Promise<IBaseSearch> {
        const geocoder = new google.maps.Geocoder();

        return new Promise((resolve, reject) => {

            const cacheIndex = this.geocoderCache.findIndex((cache: any) => cache.query === query);

            if (cacheIndex > -1) {
                return resolve({ ...this.geocoderCache[cacheIndex], cache: true });
            } else {
                geocoder.geocode({ address: query }, (results: any[], status: string) => {
                    if (status === google.maps.GeocoderStatus.OK) {

                        const result = {
                            query,
                            address: results[0].formatted_address,
                            latitude: results[0].geometry.location.lat(),
                            longitude: results[0].geometry.location.lng(),
                        };

                        this.geocoderCache.push(result);

                        resolve(result);
                    } else {
                        reject(null);
                    }
                });
            }
        });
    }
}

// Export a singleton instance in the global namespace
export const GoogleMapsService = new GMapsService();
